// Vitrine des courriers types. Le papier reprend le nom du cabinet ; le corps reste la trame.
import { useState } from 'react';
import { useDocumentTemplates } from '../../hooks/queries/useDocumentGeneration';
import { useTenantBranding } from '../../contexts/ThemeContext';

export function LetterModelsShelf() {
  const { data: templates = [], isLoading } = useDocumentTemplates(true);
  const { branding } = useTenantBranding();
  const letters = templates.filter((t) => t.category === 'courrier');
  const [openId, setOpenId] = useState<string | null>(null);
  const open = letters.find((t) => t.id === openId) ?? null;
  const firm = branding.firm_name || 'CIME Avocats';

  if (isLoading) return <p className="text-sm text-neutral-500">Chargement des courriers…</p>;

  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="border-b border-neutral-200 px-5 py-4">
        <h2 className="text-lg font-semibold text-cime-text-primary">Courriers types</h2>
        <p className="mt-1 text-sm text-neutral-500">
          En-tête {firm}. Depuis un dossier, « Nouveau courrier » remplit le nom du client, la partie adverse et la référence, puis l’avocat complète les trous.
        </p>
      </div>
      <div className="grid flex-1 content-start grid-cols-1 gap-3 overflow-y-auto p-5 sm:grid-cols-2">
        {letters.map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={() => setOpenId(t.id)}
            className="rounded-lg border border-neutral-200 bg-white p-4 text-left hover:border-cime-primary"
          >
            <p className="text-[10px] font-semibold uppercase tracking-wider" style={{ color: branding.color_primary }}>
              {firm}
            </p>
            <p className="mt-2 text-sm font-semibold text-neutral-800">{t.name}</p>
            {t.description && <p className="mt-1 text-xs text-neutral-500">{t.description}</p>}
          </button>
        ))}
        {letters.length === 0 && (
          <p className="text-sm text-neutral-500">Aucun courrier type pour le moment.</p>
        )}
      </div>

      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" data-cime-modal>
          <div className="flex max-h-[88vh] w-full max-w-2xl flex-col overflow-hidden rounded-lg bg-white shadow-xl">
            <div className="flex items-center justify-between border-b border-neutral-200 px-5 py-3">
              <h3 className="text-sm font-semibold text-neutral-800">{open.name}</h3>
              <button type="button" className="text-sm text-neutral-500" onClick={() => setOpenId(null)}>Fermer</button>
            </div>
            <article className="overflow-y-auto px-10 py-8">
              <header className="border-b-2 pb-3" style={{ borderColor: branding.color_primary }}>
                <p className="font-serif text-lg font-semibold" style={{ color: branding.color_primary }}>{firm}</p>
                <p className="text-xs text-neutral-500">À en-tête du cabinet</p>
              </header>
              <pre className="mt-6 whitespace-pre-wrap font-sans text-sm leading-relaxed text-neutral-800">{open.body_md}</pre>
            </article>
          </div>
        </div>
      )}
    </div>
  );
}
